// extracted by css-extract-rspack-plugin
export default {"section":"MiniPickerItem-module__section___sox6y","rightSection":"MiniPickerItem-module__rightSection___HPi7k","leftSection":"MiniPickerItem-module__leftSection___a1tkH"};